var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.css,attrs:{"color":_vm.color,"to":_vm.to}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }